export default {
  "nl": {
    "session": {
      "error_internalserver": {
        "goback": "Ga terug",
        "subtitle": "Oops, er is een onverwachte fout opgetreden.",
        "title": "500"
      },
      "error_notfound": {
        "goback": "Ga terug",
        "subtitle": "Sorry, de pagina die je zoekt kan niet gevonden worden.",
        "title": "404"
      },
      "expired": {
        "text": "De sessie is verlopen vanwege inactiviteit. Om veiligheidsredenen moet je opnieuw inloggen. \n\nKlik op OK om naar het inlogscherm te worden doorgestuurd.",
        "title": "Sessie verlopen."
      },
      "logout_impersonate": {
        "text": "Een logout actie werd geactiveerd tijdens een impersonatie.",
        "title": "Impersonatie gestopt."
      },
      "noaccess": {
        "text": "Je hebt momenteel geen toegang tot deze pagina, je zal teruggeleid worden naar de hoofdpagina.",
        "title": "Toegang geweigerd voor {subdomain}"
      }
    }
  }
}